import { SELECIONAR_AGENDAMENTO_VIAGEM } from '../../actions/types'

const initialState = null
const estadoInicial = {
  id: null,
  veiculo: {},
  notaFiscal: {
    id: null,
    valor: 0,
    numero: null,
    serie: null,
    uf: null,
    dataEmissao: null,
    base64NotaFiscal: null,
    imagemNotaFiscal: null,
    urlImagem: null,
  }
}

export default function reducerAgendamentoViagemSelecionado (state = estadoInicial, action = initialState) {
  switch (action.type) {
    case SELECIONAR_AGENDAMENTO_VIAGEM: {
      if (action.payload == null) {
        return estadoInicial;
      }
      return action.payload;
    }

    default: {
      return state
    }
  }
}